export default "__VITE_PUBLIC_ASSET__fa858757__"